import { useEffect, useState } from 'react'

import { DataStore, SortDirection } from '@aws-amplify/datastore'
import { DgtPdWorkCenter } from '../../../models'
import Select from 'react-select'

const SelectedWorkCenter = ({ show, onChange, setFirstWcValue }) => {
  const [masterWorkCenters, setMasterWorkCenters] = useState([])

  useEffect(() => {
    if (show) {
      const fetchWorkCenter = async () => {
        try {
          const workCenters = await DataStore.query(DgtPdWorkCenter, s => s.active("eq", true), {
            sort: s => s.id(SortDirection.ASCENDING)
          })
          setMasterWorkCenters(workCenters)
          setFirstWcValue(`${workCenters[0].id}_${workCenters[0].description}`)
        } catch (error) {
          console.log(error)
        }
      }
      fetchWorkCenter()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  return <Select
    menuPortalTarget={document.body}
    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
    placeholder="เลือก WorkCenter ที่ต้องการ"
    onChange={onChange}
    options={masterWorkCenters.map(wc => {
      return { value: `${wc.id}_${wc.description}`, label: `${wc.id}_${wc.description}`}
    })}
  />
}

export default SelectedWorkCenter